import AccountPending from 'features/advance/screens/registration/AccountPending/AccountPending';
import React from 'react';

const AccountPendingPage = () => <AccountPending />;

export default AccountPendingPage;
